// redux/slices/isAdminSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isSuperUser: false, // Флаг, указывающий, является ли пользователь администратором
};

const isAdminSlice = createSlice({
    name: 'isAdmin',
    initialState,
    reducers: {
        setAdminStatus: (state, action) => {
            state.isSuperUser = action.payload;
        },
    },
});

export const { setAdminStatus } = isAdminSlice.actions;
export default isAdminSlice.reducer;
